<template>
  <div>
    <div class="d-flex" id="wrapper" :class="{ toggled: isSidebar }">
      <app-sidebar></app-sidebar>
      <div id="page-content-wrapper" style="width:100%">
        <i
          class="material-icons"
          id="menu-toggle"
          @click="isSidebar = !isSidebar"
          >view_headline</i
        >
        <app-navbar></app-navbar>

        <div class="container-fluid mt-5">
          <div class="row mt-5">
            <div class="col-sm-12">
              <vs-breadcrumb
                align="left"
                :items="[
                  { title: 'You are here : ' },
                  {
                    title: 'Dashboard',
                    url: '/#/dashboard/communicationOfficer/home'
                  },
                  {
                    title: 'Material Archives',
                    active: true
                  }
                ]"
              ></vs-breadcrumb>
              <div class="frm-title pl-0">
                <div class="heading mt-1">
                  <h3 class="text-secondary-2 text-center">Material Archives</h3>
                </div>
              </div>
            </div>
          </div>

         <!-- <div class="row"> -->
           <h3 class="text-blue">Filter By</h3>
            <form id="msform" class="mb-4">
              <fieldset>
                <div class="row mt-3">
                  <div class="col-md-5">
                    <div class="form-group">
                      <label style="font-weight:700;" for="first">Subprogram</label>
                      <selectize
                        id="select-state"
                        v-model="subprogramId"
                        :searchable="true"
                        :settings="subprogramsettings"
                      >
                      <option
                          v-for="(item, index) in subprogramArr"
                          :key="index"
                          :value="item.id"
                          >{{ item.title }}</option>
                      </selectize>
                    </div>
                  </div>
                  <div class="col-md-5">
                    <div class="form-group">
                      <label style="font-weight:700;" for="first">Project</label>
                      <selectize
                        id="select-state"
                        v-model="projectId"
                        :searchable="true"
                        :settings="projectsettings"
                      >
                        <option
                          v-for="(item, index) in projectArr"
                          :key="index"
                          :value="item.id"
                          >{{ item.title }}</option>
                      </selectize>
                    </div>
                  </div>
                  <div class="col-md-2">
                    <div class="form-group text-center">
                      <b-button
                      pill
                      variant="outline-primary"
                      @click="allTrainings"
                      size="sm"
                      class="mt-4"
                    >Reload All</b-button>
                    </div>
                  </div>
                </div>
              </fieldset>
            </form>
          <!-- </div> -->
          
          <!-- new design starts -->
          <div class="row mb-4">
           <div class="col-sm-12">
            <div class="table-responsive">
              <table class="table table-hover table-stripped">
                <tr>
                  <th>Sr#</th>
                  <th>Title</th>
                  <th>Subprogram</th>
                  <th>Project</th>
                  <th class="text-center">Start Date - End Date</th>
                  <th class="text-center">Status</th>
                  <th class="text-center">Action</th>
                </tr>
                <tr v-for="(training,index) in trainings" v-bind:key="index">
                  <td>{{index+1}}</td>
                  <td  class="text-capitalize w-25">{{training.title}}</td>
                  <td>{{training.subprogram.title}}</td>
                  <td class="text-capitalize">{{training.project.title}}</td>
                  <td v-if="training.startdate != null & training.enddate != null">
                    <vs-chip class="mr-1" color="primary pr-0">
                      <Strong style="font-size:12px;">{{training.startdate}}<b style="color: #fff"> - </b>{{training.enddate}}</Strong>
                    </vs-chip>
                  </td>
                  <td v-else>
                    <vs-chip class="mr-1" color="primary pr-0">
                      <Strong style="font-size:12px;">Not defined yet</Strong>
                    </vs-chip>
                  </td>

                  <td>
                    <vs-chip class="mr-1" color="success">
                        <Strong style="font-size:12px;">Material Uploaded</Strong>
                    </vs-chip>
                  </td>
                  <td class="text-center"> 
                     <router-link :to="{ path: '/dashboard/communicationOfficer/uploads', query: { training: training.training_code}}">
                      <b-button pill variant="outline-success" size="sm" class="mr-1">
                        View Materials
                      </b-button>
                    </router-link>
                  </td>
                </tr>
              </table>
              <p class="text-center mt-5" v-if="!this.trainings.length">
                <b class="text-danger">No training found for the selected Sub Program and Project</b>
              </p>
            </div>
          </div>
          </div>
          <!-- new design ends -->
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Navbar from "./Navbar";
import Sidebar from "./Sidebar";
import Selectize from "vue2-selectize";
import axios from "axios";
export default {
  data: () => ({
    isSidebar: false,
    trainings: [],
    allMaterialArr: [],
    trainingId: "",
    trainingCode: "",
    BASEPATHDYNAMIC: "",
    subprogramArr: [],
    projectArr: [],
    trainingArr: [],
    subprogramId: '',
    projectId: '',
    subprogramsettings: {
      searchField: ["text"],
      placeholder: "Select subprogram here"
    },
    projectsettings: {
      searchField: ["text"],
      placeholder: "Select project here"
    },
  }),
  components: {
    "app-navbar": Navbar,
    "app-sidebar": Sidebar,
     Selectize,
  },
  watch: {
    subprogramId(val){
      this.filterProject(val);
    },
    projectId(){
      this.showFilterResult();
    }
  },
   mounted() {
   axios.defaults.headers['Authorization'] = localStorage.getItem('token')
    this.allTrainings();
    this.allSubProgram();
  },
  methods: {
    // for active li's
    allTrainings: function allTrainings(){
    this.openLoading();
    axios
      .get(
        localStorage.getItem("BASE_PATH") +
          "/comm/officer/training/archives/show"
     
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.trainings = response.data;
      });
    },
    // shows sub program form dropdown in filter
    allSubProgram: function allSubProgram(){
      this.openLoading();
      axios.get(localStorage.getItem("BASE_PATH") + "/comm/officer/subprogram/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.subprogramArr = response.data;
      });
    },
    // shows project form dropdown in filter
    filterProject: function filterProject(id){
      this.projectId = '';
      this.openLoading();
      axios.get(localStorage.getItem("BASE_PATH") + "/comm/officer/project/"+id+"/get"
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
        this.closeLoading();
        this.projectArr = response.data;
      });
    },

    // shows filter value
    showFilterResult: function showFilterResult(){
      if(this.subprogramId != "" && this.projectId != ""){
        this.openLoading();
        this.trainings = [];
        axios.get(localStorage.getItem("BASE_PATH") + "/comm/officer/training/filter/"+this.subprogramId+"/"+this.projectId
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.trainings = response.data;
        });
      } else {
        return false;
      }
    },


    showMaterials: function showMaterials(trId){
      this.trainingId = trId;
      this.trainingMaterialsLoad(trId);
    },
    trainingMaterialsLoad: function trainingMaterialsLoad(id) {
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainingmaterils/knowledgebase/get/" +
            id +
            ""
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          this.allMaterialArr = response.data;
        });
    },
    loadMaterials: function loadMaterials(type){
      this.openLoading();
      axios
        .get(
          localStorage.getItem("BASE_PATH") +
            "/trainingmaterils/type/get/" +
            type +
            "" +
            "/" +
            this.trainingId
       
        )
        .then(response => {
          if(response.data.unAuth){
            this.$toasted.global.errorMsg('Your are Unauthorized. Need to Login Again');
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
            
          }
          if(response.data.tokenExpired){
            this.$toasted.global.errorMsg(response.data.tokenExpired);
            localStorage.clear();
            setTimeout(() => {
                this.$router.push("/");
            }, 1000);
          }
          this.closeLoading();
          if (type === "Word") {
            this.WordFilter = response.data;
          } else if (type === "PDF") {
            this.PDFFilter = response.data;
          } else if (type === "Html") {
            this.HtmlFilter = response.data;
          } else if (type === "Video") {
            this.VideosFilter = response.data;
          } else if (type === "PPT") {
            this.PPTFilter = response.data;
          }
        });
    },

    openLoading() {
      this.$vs.loading({
        type: "material"
      });
    },
    closeLoading() {
       
      this.$vs.loading.close();
    },
    showForm() {
      this.isForm = false;
      this.isFormData = true;
    },
    successUpload() {
      this.$vs.notify({
        color: "success",
        title: "Upload Success",
        text: "Files have been Uploaded, consectetur"
      });
    }
    // togglemenu() {
    //   $("#wrapper").toggleClass("toggled");
    // }
  }
};
</script>
<style scoped>
.trainings {
  background-color: #e6f4ff;
  border: 2px solid #9fdcf7;
  min-height: 85vh;
  max-height: 85vh;
  overflow: auto;
}
.clr-border-blue{
   min-height: 85vh;
  max-height: 85vh;
   overflow: auto;
}
ul li {
  cursor: pointer;
}
a {
  cursor: pointer;
}
#menu-toggle {
  display: none;
}

@media (max-width: 768px) {
  #menu-toggle {
    display: block;
  }
}
.vs-avatar--text {
  text-transform: uppercase !important;
}
/* .vs-card--header {
 background: #cccccc7a;
} */
.vs-card--content {
  margin-bottom: 0px !important;
}

.kb-box {
  width: 100%;
  height: auto;
  background: #fff;
  /* border-radius: 8px; */
  margin-bottom: 20px !important;
  display: block;
  -webkit-box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  box-shadow: 0 4px 25px 0 rgba(0, 0, 0, 0.1);
  -webkit-transition: all 0.3s ease;
  transition: all 0.3s ease;
  /* padding:5px; */
}
.title-header {
  /* border-radius: 8px; */
  /* margin-bottom: 10px; */
  display: block;
  /* -webkit-box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
  box-shadow: 0 4px 25px 0 rgba(0,0,0,.1);
  -webkit-transition: all .3s ease;
  transition: all .3s ease; */
  background: #cccccc7a;
  padding: 5px;
  border-left: 3px solid #06a6e0;
}
.body-box {
  padding: 15px 5px;
}
.footer {
  padding: 15px 5px;
}

.myNavbar {
  color: rgb(255, 255, 255);
}
.dflex {
  display: flex;
}
.fcenter {
  justify-content: center;
  align-items: center;
}
.pleft-5 {
  margin-left: 5px;
}

@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
.active-bg{
  background: #eedfd1 !important;
}
.hover-on-li:hover{
  background: #eedfd1 !important;
}
#msform fieldset {
    padding: 10px;
    background: #e8e8e8;
    border: 0 none;
    border-radius: 2rem;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    width: 100%;
    margin: 0;
    border: 2px solid #ccc;
    padding-bottom: 20px;
    position: relative;
}
.text-blue {
  color: #00a4ea;
}

</style>
